import React, { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { FaArrowRight } from "react-icons/fa";
import Lightbox from "react-image-lightbox";
import { Link } from "react-router-dom";
import ServiceModal from "../ServiceModal/ServiceModal";

const HomeTwoSingleCase = ({ galleryItem, index, filterGalleryItems }) => {
  const { img, title, tagline, excerpt } = galleryItem;
  const [photoIndex, setPhotoIndex] = useState(index);
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const lightboxImages = filterGalleryItems.map((img) => img.img);
  const images = lightboxImages;

  return (
    <>
      {/* Service Modal */}
      <ServiceModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        service={galleryItem}
      />

      {open && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}

      <div
        className={
          img === "assets/img/case/case-3.jpg"
            ? "col-xl-6 col-lg-6 col-md-6"
            : "col-xl-3 col-lg-3 col-md-6 grid-item"
        }
      >
        <div className="case__item mb-30 fix">
          <div className="case__thumb w-img p-relative">
            <img src={img} alt="case" />
            <div className="case__info p-absolute transition-3">
              <h4>
                <span style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
                  {title}
                </span>
              </h4>
              <span
                style={{
                  display: 'block',
                  marginBottom: '15px',
                  lineHeight: '1.6',
                  fontSize: '15px'
                }}
              >
                {tagline || excerpt}
              </span>
              <button
                onClick={() => setIsModalOpen(true)}
                style={{
                  background: 'rgba(87, 73, 255, 0.95)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  marginTop: '5px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(87, 73, 255, 1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(87, 73, 255, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(87, 73, 255, 0.95)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Learn More <FaArrowRight style={{ fontSize: '12px' }} />
              </button>
            </div>
            <div className="case__info case__info-2 p-absolute transition-3">
              <h4>
                <span style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
                  {title}
                </span>
              </h4>
              <span
                style={{
                  display: 'block',
                  marginBottom: '15px',
                  lineHeight: '1.6',
                  fontSize: '15px'
                }}
              >
                {tagline || excerpt}
              </span>
              <button
                onClick={() => setIsModalOpen(true)}
                style={{
                  background: 'rgba(87, 73, 255, 0.95)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  marginTop: '5px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(87, 73, 255, 1)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(87, 73, 255, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(87, 73, 255, 0.95)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Learn More <FaArrowRight style={{ fontSize: '12px' }} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeTwoSingleCase;
